import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d81fc91e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d81fc91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81fc91e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d81fc91e')) {
      api.createRecord('d81fc91e', component.options)
    } else {
      api.reload('d81fc91e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d81fc91e&scoped=true&", function () {
      api.rerender('d81fc91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderData/index.vue"
export default component.exports